import {DYNAMIC_LAYOUT_SPACING} from 'ui-library/DynamicLayout';

export const DND_BLOCK_SPACING = DYNAMIC_LAYOUT_SPACING;
// While dragging, if the user hovers over a block, we put a blue line to preview where the block will be
// dropped. This constant is the width of that bar
export const DND_BLOCK_HOVER_PREVIEW_WIDTH = 3; // px
